import http from "./Http";

export default {
    getFluxoCaixaGerencialPivotGrid: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/pivotgrid', data)
    },
    getFluxoCaixaGerencialAnaliticoDataGrid: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/analiticoDataGrid', data)
    },
    getSituacaoEmpresaMestre: function() {
        return http.get("./api/financeiro/fluxocaixagerencial/situacaoEmpresaMestre");
    },
    postPerfilGerenciais: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/postPerfilGerenciais', data)
    },
    deletePerfilGerenciais: function (handle) {
        return http.post('./api/financeiro/fluxocaixagerencial/deletePerfilGerenciais/' + handle)
    },
    getPerfilGerenciais: function (handle) {
        return http.get('./api/financeiro/fluxocaixagerencial/getPerfilGerenciais/' + handle)
    },
    // Handle + nome dos itens de um lookup do Filtro avancado. O perfil grava so os
    // handles; sem o nome o select2 nao tem como repintar a selecao ao carregar o perfil.
    getDescricoesLookup: function (entityName, handles) {
        return http.post('./api/financeiro/fluxocaixagerencial/descricoesLookup', { entityName: entityName, handles: handles })
    },
    getFluxoCaixaGerencialSaldosBancarios: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/saldosBancarios', data)
    },
    // Rota unificada (pivot + saldos numa requisicao so). As duas rotas separadas acima
    // continuam existindo, mas a tela usa esta: disparar as duas em paralelo nao funcionava
    // — o WES exige sessao gravavel na requisicao WebApi autenticada, entao elas
    // serializavam no lock de sessao e dividiam o mesmo orcamento de 120s do gateway.
    getFluxoCaixaGerencialPivotGridComSaldos: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/pivotgridComSaldos', data)
    }
}
